import axios from 'axios';

const sendEmail = async (name, email, message) => {

  const url = 'https://b3depp75a3.execute-api.us-east-2.amazonaws.com/send-email'; // Your API endpoint
  const data = {
    email: email,
    fullName: name,
    message: message.trim()  // Just send the raw message, AWS will handle the formatting
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log('Email sent successfully:', response.data);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error sending email:', error.response?.data || error.message);
    return { success: false, error: error.response?.data || error.message };
  }
};

export default sendEmail;